import type {
  ObsoletePropertiesHyphen,
  StandardLonghandPropertiesHyphen,
  VendorPropertiesHyphen,
} from 'csstype';
import type { StandardShorthandPropertiesHyphen } from 'csstype';
import { css } from 'styled-components';

import type { Maybe } from '@/lib/types';

import { media } from './media';
import type { BreakpointsKeys } from './types';

type Props = ObsoletePropertiesHyphen &
  StandardLonghandPropertiesHyphen &
  StandardShorthandPropertiesHyphen &
  VendorPropertiesHyphen;

export const responsive = <Prop extends keyof Props>(
  prop: Prop,
  mobileValue: Props[Prop],
  desktopValue: Props[Prop],
  breakpoint: BreakpointsKeys = 'md',
) => `
  ${prop}: ${mobileValue};
  ${
    breakpoint &&
    `
    ${media[breakpoint].up} {
        ${prop}: ${desktopValue};
      }
    `
  }
`;

export const conditionalStyle = <Prop extends keyof Props>(
  shouldApply: Maybe<boolean>,
  prop: Prop,
  value: Props[Prop],
) =>
  !!shouldApply &&
  css`
    ${prop}: ${value};
  `;

export const horizontalCenter = `
  content: "";
  position: absolute;
  left: 50%;
  transform: translate(-50%);
`;

export const verticalCenter = `
  content: "";
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
`;

export const absoluteCenter = `
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;

export const hiddenUp = (breakpoint: BreakpointsKeys) => `
  ${media[breakpoint].up} {
    display: none;
  }
`;

export const hiddenDown = (breakpoint: BreakpointsKeys) => `
  ${media[breakpoint].down} {
    display: none;
  }
`;

export const hiddenOnly = (breakpoint: BreakpointsKeys) => `
  ${media[breakpoint].only} {
    display: none;
  }
`;
